<template>
    <div class="caseStudySlider__sliderContainer"
         v-cloak
         data-aos="fade"
         data-aos-easing="ease-in-sine"
         data-aos-duration="600"
         data-aos-offset="300"
         data-aos-delay="125"
    >
        <Splide class="caseStudySlider__slider" :options="options">
            <SplideSlide class="caseStudySlider__slide slide" v-for="(slide, i) in slides" :key="i">
                <CaseStudyCard
                    :url="slide.url"
                    :title="slide.title"
                    :categories="slide.categories"
                    :img="{
                        url: slide.img,
                        height: modifier === 'listing' ? 383 : 650,
                        width: modifier === 'listing' ? 588 : 484
                    }"
                    :modifier="modifier"
                />
            </SplideSlide>
        </Splide>
    </div> <!-- .sliderWrap -->
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import { defineComponent, defineProps } from 'vue'
import CaseStudyCard from './case_study_card.vue';

export default defineComponent({
    props: {
        slides: {
            type: Object,
        },
        options: {
            type: Object,
        },
        theme: {
            type: String,
            default: ""
        },
        modifier: {
            type: String,
            default: ""
        }
    },
    components: {
        Splide,
        SplideSlide,
        CaseStudyCard
    },
});
</script>
